/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
@Component({
  templateUrl:'./edit.html'
})

export class EditSettingContent implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location
  ){}

  private content:string='<p></p>';


  private data:any={
    'code':'',
    'desc':'',
    'content':''
  }

  private code:string = '';
  private isProgress=true;
  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.code=params['code'];
    });

    if(this.code!=''){
      this.getData();
    }
  }

  private onReady():void{
    this.content = this.data.content;
  }

  private onChange():void{
    this.data.content = this.content;
  }

  private getData():void{
    this.HttpService.getData(API.settingContent+'/'+this.code).then(res=>{
      this.data = res.data;
      this.content = this.data.content;
      this.isProgress=false;
    })
  }

  private submit():void{
    this.HttpService.postData(API.settingContent,{
      'code':this.code,
      'content':this.data.content
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }

}




// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/settingContent/EditSettingContent.component.ts